import React, { FC } from 'react';
import { Grid, Link, Typography } from '@material-ui/core';

import { GroupFragment } from 'api';
import { generateLink } from 'Links';

interface IProps {
  group: GroupFragment;
}

const TitleCell: FC<IProps> = ({ group }) => (
  <Grid item xs zeroMinWidth container>
    <Typography variant="subtitle2" noWrap>
      <Link title={group.title} component={generateLink(`/group/${group.id}`)}>
        {group.title}
      </Link>
    </Typography>
  </Grid>
);

export default TitleCell;
